/* eslint-disable no-restricted-syntax, no-debugger */

const isServer = typeof window === 'undefined';

export function suspectInfiniteLoop(target, name, descriptor) {
  if (isServer) return descriptor || target;

  let fn;
  let calls = 0;
  setInterval(() => { calls = 0; }, 10000);

  function suspectedInfiniteLoop(...args) {
    calls++;
    if (calls === 100) {
      debugger;
    }
    if (calls > 100) {
      throw new Error('Infinite loop detected');
    }
    return fn.apply(this, args);
  }

  if (descriptor && descriptor.value) {
    // decorator
    if (typeof descriptor.value === 'function') {
      fn = descriptor.value;
      descriptor.value = suspectedInfiniteLoop;
      return descriptor;
    }
  } else if (typeof target === 'function') {
    fn = target;
    return suspectedInfiniteLoop;
  }

  throw new Error('Invalid arguments passed to suspectInfiniteLoop');
}



// WEBPACK FOOTER //
// ./spa/debug.jsx